// components/LupaAbsenModal.jsx
import { motion } from "framer-motion";
import { useState } from "react";

export default function LupaAbsenModal({
  open,
  onClose,
  lupaType,
  items = [],
  jamMasuk,
  setJamMasuk,
  jamPulang,
  setJamPulang,
  namaKaryawan: propNamaKaryawan,
  dataKaryawan,
}) {
  const [lokasiAbsen, setLokasiAbsen] = useState("");
  const [keterangan, setKeterangan] = useState("");

  if (!open) return null;

  const item = items[0] || {};
  const isLupaPulang = lupaType === "lupa_pulang";
  const jenisAbsen = isLupaPulang ? "Pulang" : "masuk";
  const jenisAbsenLabel = isLupaPulang ? "Absen Pulang" : "Absen masuk";
  const inputJam = isLupaPulang ? jamPulang : jamMasuk;
  const setInputJam = isLupaPulang ? setJamPulang : setJamMasuk;
  const tanggal = formatTanggal(item.tanggal);
  const namaKaryawan = resolveEmployeeName(propNamaKaryawan, dataKaryawan, item);
  const formLengkap = inputJam && lokasiAbsen.trim() && keterangan.trim();
  const sapaan = namaKaryawan ? `Halo Tim IT, saya ${namaKaryawan}.` : `Halo Tim IT,`;
  const message = `${sapaan} Kemarin ${tanggal} saya lupa absen ${jenisAbsen}. Lokasi absen: ${lokasiAbsen.trim() || "{ lokasi absen }"}. Keterangan: ${keterangan.trim() || "{ keterangan }"}. Silakan cek CCTV sekitar jam ${inputJam || "{ input jam }"}.`;

  const handleConfirm = () => {
    if (!formLengkap) return;

    window.location.href = `https://wa.me/6282177826596?text=${encodeURIComponent(message)}`;
  };

  const handleClose = () => {
    setLokasiAbsen("");
    setKeterangan("");
    onClose?.();
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.4)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 999,
      }}
    >
      <motion.div
        initial={{ y: 40, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        style={{
          width: 380,
          maxWidth: "calc(100vw - 32px)",
          maxHeight: "86vh",
          overflowY: "auto",
          background: "linear-gradient(180deg,#4f7cff,#3b5bdb)",
          borderRadius: 28,
          padding: 20,
          color: "white",
        }}
      >
        {/* Header */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <img
              src="/info.png"
              alt="avatar"
              style={{
                width: 44,
                height: 44,
                borderRadius: "50%",
                objectFit: "cover",
                border: "2px solid rgba(255,255,255,0.6)",
              }}
            />
            <div>
              <div style={{ fontSize: 12 }}>Informasi</div>
              <div style={{ fontSize: 16, fontWeight: 700 }}>
                Pelaporan Lupa Absen
              </div>
            </div>
          </div>

          <div
            style={{
              padding: "6px 12px",
              borderRadius: 20,
              background: "#ef4444",
              fontSize: 12,
              fontWeight: 600,
            }}
          >
            Revisi
          </div>
        </div>

        {/* Informasi */}
        <div
          style={{
            marginTop: 16,
            background: "white",
            color: "#1f2937",
            borderRadius: 20,
            padding: 16,
            border: "1px solid rgba(255,255,255,0.72)",
            boxShadow: "0 12px 24px rgba(15,23,42,0.12)",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10 }}>
            <div
              style={{
                width: 34,
                height: 34,
                borderRadius: 12,
                background: "#dbeafe",
                color: "#1d4ed8",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: 900,
              }}
            >
              i
            </div>
            <div>
              <div style={{ fontSize: 11, fontWeight: 800, color: "#2563eb", textTransform: "uppercase" }}>
                Informasi
              </div>
              <h3 style={{ margin: 0, fontSize: 17, color: "#1e3a8a" }}>
                Ketentuan Koreksi Absensi
              </h3>
            </div>
          </div>
          <p style={{ margin: 0, fontSize: 14, lineHeight: 1.6, color: "#374151" }}>
            Dikarenakan adanya penyalahgunaan pelaporan lupa absen, setiap
            pengajuan koreksi absensi hanya dapat dilakukan melalui Tim IT
            dengan verifikasi rekaman CCTV. Apabila hasil verifikasi valid, jam
            absensi akan disesuaikan dengan kondisi sebenarnya.
          </p>
        </div>

        {/* Pelaporan */}
        <div
          style={{
            marginTop: 12,
            background: "#ffffff",
            color: "#1f2937",
            borderRadius: 20,
            padding: 16,
            border: "1px solid rgba(255,255,255,0.72)",
            boxShadow: "0 12px 24px rgba(15,23,42,0.12)",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 12 }}>
            <div
              style={{
                width: 34,
                height: 34,
                borderRadius: 12,
                background: "#dcfce7",
                color: "#15803d",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: 900,
              }}
            >
              WA
            </div>
            <div>
              <div style={{ fontSize: 11, fontWeight: 800, color: "#16a34a", textTransform: "uppercase" }}>
                Pelaporan
              </div>
              <h3 style={{ margin: 0, fontSize: 17, color: "#14532d" }}>
                Template WhatsApp
              </h3>
            </div>
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, marginBottom: 12 }}>
            {namaKaryawan && (
              <div style={{ gridColumn: "1 / -1", background: "#f8fafc", borderRadius: 12, padding: 10, border: "1px solid #e5e7eb" }}>
                <div style={{ fontSize: 11, color: "#64748b", fontWeight: 700 }}>Nama Karyawan</div>
                <div style={{ fontSize: 13, color: "#111827", fontWeight: 800 }}>{namaKaryawan}</div>
              </div>
            )}
            <div style={{ background: "#f8fafc", borderRadius: 12, padding: 10, border: "1px solid #e5e7eb" }}>
              <div style={{ fontSize: 11, color: "#64748b", fontWeight: 700 }}>Tanggal</div>
              <div style={{ fontSize: 13, color: "#111827", fontWeight: 800 }}>{tanggal}</div>
            </div>
            <div style={{ background: "#f8fafc", borderRadius: 12, padding: 10, border: "1px solid #e5e7eb" }}>
              <div style={{ fontSize: 11, color: "#64748b", fontWeight: 700 }}>Jenis</div>
              <div style={{ fontSize: 13, color: "#111827", fontWeight: 800 }}>{jenisAbsenLabel}</div>
            </div>
          </div>

          <div
            style={{
              padding: 12,
              borderRadius: 12,
              background: "#fefce8",
              border: "1px solid #fde68a",
              color: "#374151",
              fontSize: 13,
              lineHeight: 1.45,
            }}
          >
            {message}
          </div>
          <div style={{ marginTop: 14 }}>
            <label
              style={{
                fontSize: 13,
                color: "#6b7280",
                display: "block",
                marginBottom: 6,
                fontWeight: 700,
              }}
            >
              Jam perkiraan lupa absen {jenisAbsen}
            </label>
            <input
              type="time"
              step="60"
              value={inputJam}
              onChange={(e) => setInputJam?.(e.target.value)}
              style={{
                width: "100%",
                boxSizing: "border-box",
                padding: "12px 14px",
                borderRadius: 12,
                border: "1px solid #d1d5db",
                fontSize: 16,
                fontWeight: 700,
                color: "#111827",
                background: "#f9fafb",
              }}
            />
          </div>
          <div style={{ marginTop: 14 }}>
            <label
              htmlFor="lokasi-absen"
              style={{
                fontSize: 13,
                color: "#6b7280",
                display: "block",
                marginBottom: 6,
                fontWeight: 700,
              }}
            >
              Lokasi absen
            </label>
            <input
              id="lokasi-absen"
              type="text"
              value={lokasiAbsen}
              onChange={(e) => setLokasiAbsen(e.target.value)}
              placeholder="Misal: parkiran"
              style={{
                width: "100%",
                boxSizing: "border-box",
                padding: "12px 14px",
                borderRadius: 12,
                border: "1px solid #d1d5db",
                fontSize: 14,
                color: "#111827",
                background: "#f9fafb",
              }}
            />
          </div>
          <div style={{ marginTop: 14 }}>
            <label
              htmlFor="keterangan-lupa-absen"
              style={{
                fontSize: 13,
                color: "#6b7280",
                display: "block",
                marginBottom: 6,
                fontWeight: 700,
              }}
            >
              Keterangan
            </label>
            <textarea
              id="keterangan-lupa-absen"
              value={keterangan}
              onChange={(e) => setKeterangan(e.target.value)}
              placeholder="Jika absen di lapangan, masukkan POD terakhir"
              rows={3}
              style={{
                width: "100%",
                boxSizing: "border-box",
                padding: "12px 14px",
                borderRadius: 12,
                border: "1px solid #d1d5db",
                fontSize: 14,
                color: "#111827",
                background: "#f9fafb",
                resize: "vertical",
                fontFamily: "inherit",
              }}
            />
          </div>
        </div>

        {/* Action */}
        <div style={{ display: "flex", gap: 12, marginTop: 14 }}>
          <button
            onClick={handleClose}
            style={{
              flex: 1,
              padding: "10px",
              borderRadius: 16,
              border: "none",
              background: "rgba(255,255,255,0.2)",
              color: "white",
              fontWeight: 600,
              fontSize: 12,
            }}
          >
            Batal
          </button>

          <button
            onClick={handleConfirm}
            disabled={!formLengkap}
            style={{
              flex: 1,
              padding: "10px",
              borderRadius: 16,
              border: "none",
              background: formLengkap ? "white" : "rgba(255,255,255,0.45)",
              color: formLengkap ? "#1e3a8a" : "rgba(30,58,138,0.55)",
              fontWeight: 600,
              fontSize: 15,
              cursor: formLengkap ? "pointer" : "not-allowed",
            }}
          >
            Konfirmasi
          </button>
        </div>
      </motion.div>
    </div>
  );
}

function formatTanggal(value) {
  if (!value) return "-";

  const date = new Date(`${value}T00:00:00`);
  if (Number.isNaN(date.getTime())) return value;

  return date.toLocaleDateString("id-ID", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}


function resolveEmployeeName(propName, propDataKaryawan, item = {}) {
  if (propName && typeof propName === 'string' && propName.trim()) {
    return propName.trim();
  }
  if (item?.nama_karyawan && typeof item.nama_karyawan === 'string' && item.nama_karyawan.trim()) {
    return item.nama_karyawan.trim();
  }
  const getFromObj = (obj) => {
    if (!obj || typeof obj !== 'object') return '';
    const fullName = [obj.nama_depan, obj.nama_belakang].filter(Boolean).join(' ').trim();
    if (fullName) return fullName;
    const userFullName = [obj.firstname || obj.first_name, obj.lastname || obj.last_name].filter(Boolean).join(' ').trim();
    if (userFullName) return userFullName;
    return (obj.nama_lengkap || obj.nama || obj.name || obj.karyawan || obj.agen || obj.nama_agen || '').trim();
  };
  if (propDataKaryawan) {
    const nameFromProp = getFromObj(propDataKaryawan);
    if (nameFromProp) return nameFromProp;
  }
  try {
    const dk = JSON.parse(localStorage.getItem('data_karyawan') || '{}');
    const nameFromDk = getFromObj(dk);
    if (nameFromDk) return nameFromDk;
  } catch {}
  try {
    const du = JSON.parse(localStorage.getItem('data_user') || '{}');
    const nameFromDu = getFromObj(du);
    if (nameFromDu) return nameFromDu;
  } catch {}
  return '';
}
